import { useEffect } from 'react';
import { BrowserRouter, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import './Styles/site.css';
import NewMenu from './Components/NewMenu';
import NewFooter from './Components/NewFooter';
import Home from './Screens/Home';
import About from './Screens/AboutUs';
import Clients from './Screens/Clients';
import Contact from './Screens/Contact';
import ReadMore from './Screens/readMore';
import NotFound from './Screens/NotFound';

const pageTitles = {
  '/about': 'Leadership',
  '/clients': 'Clients',
  '/contact': 'Contact',
  '/readMore': 'Company',
};

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const title = pageTitles[pathname];
    document.title = title ? `${title} | Sneh Communications` : 'Sneh Communications';
  }, [pathname]);

  return (
    <div className="site">
      <NewMenu />
      <main>
        <Outlet />
      </main>
      <NewFooter />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/readMore" element={<ReadMore />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
